import { Col, Empty, Form, Icon, Input, Row, Select } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { OptionProps } from 'antd/lib/select';
import { gql } from 'apollo-boost';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import styled from 'styled-components';

import { skuGroupListQuery } from './RedeemCodeTemplateList';

const { Option } = Select;
export const TipContent = styled.div`
  color: #00000066;
  line-height: 2.5;
  font-size: 10px;
  padding-left: 5px;
`;
const FormItem = Form.Item;
interface Props {
  match: any;
  form: WrappedFormUtils;
}

const skusQuery = gql`
  query {
    skus {
      id
      name
    }
  }
`;

class CreateRedeemCodeTemplateForm extends Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  getSkusList = () => {
    const { getFieldDecorator } = this.props.form;
    return (
      <Query query={skusQuery} variables={{}}>
        {({ loading, error, data }) => {
          if (error) return <div>{error.message}</div>;
          if (loading) return <div>loading...</div>;
          if (!data) {
            // @ts-ignore
            return <Empty />;
          }
          const skus = (data && data.skus) || [];
          return (
            <FormItem>
              {getFieldDecorator('skuId')(
                <Select
                  placeholder="请选择sku"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input: string, option: React.ReactElement<OptionProps>) => {
                    return String(option.props.children).indexOf(input) >= 0;
                  }}
                  style={{ width: '100%' }}
                  onChange={(value: number) => {
                    this.setState({ skuId: value });
                  }}
                >
                  {skus.map((sku: { id: number; name: string }) => (
                    <Option value={sku.id} key={sku.id}>
                      {sku.name}
                    </Option>
                  ))}
                </Select>,
              )}
            </FormItem>
          );
        }}
      </Query>
    );
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form>
        <Row gutter={24}>
          <Col span={10}>
            <FormItem>
              {getFieldDecorator('channel')(
                <Input type="text" style={{ marginBottom: 16 }} allowClear placeholder="请输入渠道" />,
              )}
            </FormItem>
          </Col>
          <Col span={10}>
            <Query query={skuGroupListQuery}>
              {({ loading, error, data }) => {
                if (error) return <div>{error.message}</div>;
                if (loading) return <div>loading...</div>;
                if (!data) {
                  // @ts-ignore
                  return <Empty />;
                }
                const skuGroups = data.skuGroups;
                return (
                  <FormItem>
                    {getFieldDecorator('skuGroupId')(
                      <Select
                        style={{ width: '100%' }}
                        placeholder="选择skuGroupId"
                        onChange={(value: number) => {
                          this.setState({
                            skuGroupId: value,
                          });
                        }}
                      >
                        {skuGroups.map((skuGroup: { id: number; name: string; description: string }) => {
                          return (
                            <Select.Option value={skuGroup.id} key={skuGroup.id}>
                              {skuGroup.description}
                            </Select.Option>
                          );
                        })}
                      </Select>,
                    )}
                  </FormItem>
                );
              }}
            </Query>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={10}>
            <FormItem>
              {getFieldDecorator('duration')(<Input type="number" placeholder="请输入有效期(天)" allowClear />)}
            </FormItem>
          </Col>
          <Col span={10}>
            <FormItem>{getFieldDecorator('desc')(<Input placeholder="请输入兑换码描述" allowClear />)}</FormItem>
          </Col>
        </Row>
        <Row style={{ marginTop: 16 }}>
          <Col span={10}>{this.getSkusList()}</Col>
          <Col span={14}>
            <TipContent>指定sku则优先兑换指定sku,指定sku售卖截止则兑换skuGroup中当前在售sku</TipContent>
          </Col>
        </Row>
        <Row gutter={24} style={{ marginTop: 16 }}>
          <Col span={10}>
            <FormItem>
              {getFieldDecorator('price')(<Input placeholder="请输入市场价" allowClear type="number" />)}
            </FormItem>
          </Col>
          <Col span={10}>
            <FormItem>
              {getFieldDecorator('activityPrice')(<Input placeholder="请输入活动价" allowClear type="number" />)}
            </FormItem>
          </Col>
        </Row>
        <Row gutter={24} style={{ marginTop: 16 }}>
          <Col span={10}>
            <FormItem>
              {getFieldDecorator('cost')(<Input placeholder="请输入课程成本" allowClear type="number" />)}
            </FormItem>
          </Col>
          <Col span={10}>
            <FormItem>
              {getFieldDecorator('marketingCost')(<Input placeholder="请输入市场成本" allowClear type="number" />)}
            </FormItem>
          </Col>
        </Row>
      </Form>
    );
  }
}

const WrappedCreateRedeemCodeTemplateForm = Form.create()(CreateRedeemCodeTemplateForm);

export { WrappedCreateRedeemCodeTemplateForm };



// WEBPACK FOOTER //
// ./src/screens/redeemCode/CreateRedeemCodeTemplateForm.tsx